<template>
  <div>
    <div
      class="coms-goods flex-start"
      v-for="(goods,index) in goodsList"
      @click="goGoodsDetail(goods)"
    >
      <img class="coms-left" :src="goods.pic_url" />
      <div class="coms-right">
        <div class="coms-good-name">{{goods.title}}</div>
        <div class="coms-good-detail">
          <div class="flex-start">
            <div class="scroll-goods-price">
              <div class="goods-list0-price">¥</div>
              <div class="goods-list1-price">{{goods.price_range[0] | price}}</div>
<!--              <div-->
<!--                v-if="goods.price_range[1]"-->
<!--                class="goods-list1-price"-->
<!--              > - {{goods.price_range[1] | price}}</div>-->
            </div>
            <div class="scroll-goods-item0-seller-price" style="margin-left:5px" v-if="goods.max_seller_reward>0">
              <div class="fan">赚</div>
              <div class="seller-price">¥{{goods.max_seller_reward}}</div>
            </div>
          </div>
          <div class="coms-sold">
            <div class="coms-sell-num">已售 {{goods.sold_count+goods.sold_show_count}}</div>
            <div class="good-thr-price">
                ¥{{goods.orig_price}}
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<style scoped>
/* 小图 */

.coms-sold{
    display: flex;
}
.coms-sold div{
    display: flex;
    align-items: center;
}
.goods-list0-price{
    font-size: 10px;
}
.goods-list1-price{
    font-size: 16px;
}
.scroll-goods-price{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
  color: #fd2840;
  text-align: center;
}
.scroll-goods-price div{
    display:flex;
    height: 18px;
    align-items: flex-end;
}
.scroll-goods-item0-seller-price{
  display: flex;
  justify-content: space-between;
  border: 1px solid #FD2840;
  border-radius: 4px;
  height: 15px;
  line-height: 15px;
  overflow: hidden;
}
.scroll-goods-item0-seller-price .fan {
  background: #fd2840;
  color: #fff;
  font-size: 12px;
  padding: 0 2px;
  line-height: 15px;
}
.scroll-goods-item0-seller-price .seller-price {
  color: #fd2840;
  font-size: 12px;
  padding: 0 2px;
  line-height: 15px;
}
.coms-good-detail {
  display: flex;
  flex-direction: column;
}
.coms-goods {
  padding: 0 10px 10px;
  margin: 5px 0;
  align-items: flex-start;
}

.coms-left {
  width: 100px;
  height: 100px;
  border-radius: 5px;
}

.coms-good-name {
  color: #333;
  font-size: 14px;
  margin-bottom: 20px;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.coms-right {
  margin-left: 10px;
  width: 240px;
  display: flex;
  flex-direction: column;
}

.coms-sell-num {
  color: #999;
  font-size: 12px;
}

.coms-tips {
  border-top: 1px solid #efefef;
  font-size: 12px;
  color: #666666;
}

.coms-tips-type {
  width: 14px;
  height: 14px;
  line-height: 14px;
  text-align: center;
  border-radius: 2px;
  color: #fff;
  margin-right: 2.5px;
  overflow: hidden;
}
.coms-tips-one {
  margin-top: 5px;
}
.coms-tips-one text {
  color: #fd2840;
}
.coms-tips-typek {
  background: #273040;
}
.coms-tips-typej {
  background: #42bd56;
}
.coms-tips-typet {
  background: #ff7500;
}
.coms-tips-typeq {
  background: #ff5a5f;
}
.good-normal-price {
  color: #fd2840;
  font-size: 17px;
  font-weight: 500;
}

.good-normal-price text {
  font-size: 12px;
}

.good-thr-price {
  color: #999;
  font-size: 12px;
  margin-left: 7.5px;
  text-decoration: line-through;
}

.good-pri-earn {
  width: auto;
  padding: 2px 2px;
  background: rgba(253, 232, 234, 1);
  border-radius: 2px;
  /* border:2rpx solid rgba(253,40,64,1); */
  font-size: 12px;
  color: #fd2840;
  text-align: center;
  margin-left: 7.5px;
}
</style>

<script>
export default {
  name: "GoodsItem1",
  components: {},
  props: {
    goodsList: {
      type: Array,
      default: []
    }
  },

  data: function() {
    return {};
  },

  methods: {
    goGoodsDetail(goods) {
      rbLink({
        name: 'GoodsDetail',
        query: {
          id: goods.id
        }
      });
     
    }
  },

  filters: {}
};
</script>




// WEBPACK FOOTER //
// GoodsItem1.vue?dfe289de